import { useMutation } from '@tanstack/react-query';
import {
  AuthOtpPinService,
  CreatePinByOtpDto,
  CreatePinByOtpEntity,
} from 'services/openapi';

export const useOtpPinCreatePin = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<CreatePinByOtpEntity, Error, CreatePinByOtpDto>({
      mutationFn: (variables: CreatePinByOtpDto) => {
        return AuthOtpPinService.otpPinControllerCreatePin(variables);
      },
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
